// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsScheduling-SchedFunctions-BulkPlanCreation-BulkPlanContent-BulkPlanFooter-BulkPlanFooter-module__createButton--u6yBV {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsScheduling/SchedFunctions/BulkPlanCreation/BulkPlanContent/BulkPlanFooter/BulkPlanFooter.module.less"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF","sourcesContent":[".createButton {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"createButton": `src-businessServices-services-bsScheduling-SchedFunctions-BulkPlanCreation-BulkPlanContent-BulkPlanFooter-BulkPlanFooter-module__createButton--u6yBV`
};
export default ___CSS_LOADER_EXPORT___;
